"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var useForceUpdate_1 = tslib_1.__importDefault(require("./useForceUpdate"));
function useSyncState(initialValue) {
    var ref = React.useRef(initialValue);
    var forceUpdate = (0, useForceUpdate_1.default)();
    return [
        function () { return ref.current; },
        function (newValue) {
            ref.current = newValue;
            // re-render
            forceUpdate();
        },
    ];
}
exports.default = useSyncState;
//# sourceMappingURL=useSyncState.js.map